import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, maxLength, ...props }, ref) => {
  const [length, setLength] = React.useState(() => (props.value || props.defaultValue || '').toString().length);
  const showCounter = !!maxLength;

  const handleChange = (e) => {
    if (showCounter) setLength(e.target.value.length);
    props.onChange?.(e);
  };

  React.useEffect(() => {
    if (showCounter && props.value !== undefined) {
      setLength(props.value.toString().length);
    }
  }, [props.value, showCounter]);

  if (!showCounter) {
    return (
      <textarea
        className={cn(
          "flex min-h-[60px] w-full rounded-md border border-white/20 bg-background px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props} />
    );
  }

  return (
    <div className="relative w-full">
      <textarea
        maxLength={maxLength}
        className={cn(
          "flex min-h-[60px] w-full rounded-md border border-white/20 bg-background px-3 py-2 pb-5 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
        onChange={handleChange} />
      <span className="absolute right-2 bottom-1.5 text-[10px] text-muted-foreground pointer-events-none">{length}/{maxLength}</span>
    </div>
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
